/**
 * Layout-only class set for question-bar icon buttons (filter, prompt library,
 * DeepDive, submit). The resting border and hover fill come from the Button's
 * `outline` / `light` / `brand` variant — do not re-declare `border-*`,
 * `bg-*`, or `text-white/*` here, or the toggled `solid` / `accent` state can't
 * win against it.
 *
 * The bar surface is brand blue (`bg-[#2d8dfe]`). Use `background="brand"` so
 * outline/light hovers lift to `--surface-brand-hover` — not `inverse`, which
 * paints ink (`#344465`) and reads as a dark charcoal disk on blue.
 */
export const QUESTION_BAR_ICON_BUTTON_CLASS =
  'flex w-fit flex-row items-center justify-center gap-1';

/** `background` prop for icon buttons on the brand-blue question bar. */
export const QUESTION_BAR_ICON_BUTTON_BACKGROUND = 'brand' as const;

/**
 * Applied to the submit button while the bar is collapsed, where the bar's own
 * `border-white/50` pill already supplies the ring. Overrides the button's
 * border tokens in `question-bar.css` — a class alone can't outrank the
 * `[data-color]` / `[data-style]` blocks that paint it white.
 */
export const QUESTION_BAR_SUBMIT_RINGLESS_CLASS = 'tp-question-bar__submit--ringless';

/** @deprecated Use QUESTION_BAR_ICON_BUTTON_CLASS — submit shares the same chrome. */
export const QUESTION_BAR_SUBMIT_BUTTON_CLASS = QUESTION_BAR_ICON_BUTTON_CLASS;
